import { FC, useState } from 'react';

import { css } from '@emotion/react';
import { ToucanComponents, ToucanColors } from '@jointoucan/toucan-design';
import { useTheme, Box } from '@mui/material';

import { AddExtensionFooter } from '~/components/shared/AddExtensionFooter';
import { InlineTranslation } from '~/components/shared/InlineTranslation';
import Layout from '~/components/shared/Layout';
import Config from '~/lib/config';

import { EnterText } from './EnterText';
import { TranslationOutput } from './TranslationOutput';

const { Typography } = ToucanComponents;

export const Bark: FC = () => {
  const theme = useTheme();
  const [sourcePhrase, setSourcePhrase] = useState<string>();

  const onTranslatePhrase = (phrase: string) => {
    setSourcePhrase(phrase);
  };

  return (
    <Layout isContained={false} hasFooter={false} isNavbarVisible={false}>
      <Box display="flex" flexDirection="column" height="100vh">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          flex="1"
          css={css`
            background: url(/images/bark/bg.svg) no-repeat center center/cover;
            ${theme.breakpoints.up('sm')} {
              overflow-y: auto;
              padding-bottom: ${theme.spacing(12)};
            }
          `}
        >
          <img
            src="/images/bark/heading.svg"
            alt="Bark woof arf header"
            width="300"
            height="153"
            css={css`
              ${theme.breakpoints.up('sm')} {
                width: 400px;
                height: 192px;
              }
            `}
          />
          <div
            css={css`
              ${theme.breakpoints.up('sm')} {
                max-width: 684px;
                filter: drop-shadow(0px 12px 36px rgba(22, 22, 22, 0.08));
              }
            `}
          >
            <EnterText onTranslatePhrase={onTranslatePhrase} />
            <TranslationOutput sourcePhrase={sourcePhrase} />
          </div>
        </Box>
        <AddExtensionFooter pageName="Bark Partner Page">
          <Typography variant="sm" color={ToucanColors.white}>
            <strong>Toucan</strong> is a browser extension that immerses you in the{' '}
            <InlineTranslation
              sourcePhrase="language"
              audioFileUrl={`${Config.SITE}/audio/bark/doggo_barkbark.mp3`}
              highlightProps={{ isLightText: true, active: true }}
              highlightHoverProps={{
                PopperProps: {
                  placement: 'top',
                  modifiers: [
                    {
                      name: 'offset',
                      enabled: false,
                      options: {
                        offset: [0, 0],
                      },
                    },
                  ],
                },
              }}
            >
              barkbark
            </InlineTranslation>{' '}
            you&rsquo;re trying to learn so that you pick it up naturally and easily. No repetitive{' '}
            <InlineTranslation
              sourcePhrase="tests"
              audioFileUrl={`${Config.SITE}/audio/bark/doggo_woof.mp3`}
              highlightProps={{ isLightText: true }}
              highlightHoverProps={{
                PopperProps: {
                  placement: 'top',
                  modifiers: [
                    {
                      name: 'offset',
                      enabled: false,
                      options: {
                        offset: [0, 0],
                      },
                    },
                  ],
                },
              }}
            >
              woofs
            </InlineTranslation>
            , no guilt-inducing push notifications.
          </Typography>
        </AddExtensionFooter>
      </Box>
    </Layout>
  );
};
